import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _dec3, _class, _class2;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import classNames from "classnames";
import { action, reaction, runInAction, makeObservable } from "mobx";
import { observer } from "mobx-react";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import Ellipsoid from "terriajs-cesium/Source/Core/Ellipsoid";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import Entity from "terriajs-cesium/Source/DataSources/Entity";
import flatten from "../../Core/flatten";
import isDefined from "../../Core/isDefined";
import { featureBelongsToCatalogItem } from "../../Map/PickedFeatures/PickedFeatures";
import prettifyCoordinates from "../../Map/Vector/prettifyCoordinates";
import MappableMixin from "../../ModelMixins/MappableMixin";
import TimeFilterMixin from "../../ModelMixins/TimeFilterMixin";
import CompositeCatalogItem from "../../Models/Catalog/CatalogItems/CompositeCatalogItem";
import TerriaFeature from "../../Models/Feature/Feature";
import { addMarker, isMarkerVisible, removeMarker } from "../../Models/LocationMarkerUtils";
import Icon from "../../Styled/Icon";
import Loader from "../Loader";
import { withViewState } from "../Context";
import Styles from "./feature-info-panel.scss";
import FeatureInfoCatalogItem from "./FeatureInfoCatalogItem";
import DragWrapper from "../Drag/DragWrapper";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let FeatureInfoPanel = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, observer(_class = (_class2 = class FeatureInfoPanel extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "pickedFeaturesReactionDisposer", undefined);
    makeObservable(this);
  }
  componentDidMount() {
    const {
      t
    } = this.props;
    const terria = this.props.viewState.terria;
    this.pickedFeaturesReactionDisposer = reaction(() => terria.pickedFeatures, pickedFeatures => {
      if (!isDefined(pickedFeatures)) {
        terria.selectedFeature = undefined;
      } else {
        terria.selectedFeature = TerriaFeature.fromEntity(new Entity({
          id: t("featureInfo.pickLocation"),
          position: pickedFeatures.pickPosition
        }));
        if (isDefined(pickedFeatures.allFeaturesAvailablePromise)) {
          pickedFeatures.allFeaturesAvailablePromise.then(() => {
            if (this.props.viewState.featureInfoPanelIsVisible === false) {
              // Panel is closed, refrain from setting selectedFeature
              return;
            }

            // We only show features that are associated with a catalog item, so make sure the one we select to be
            // open initially is one we're actually going to show.
            const featuresShownAtAll = pickedFeatures.features.filter(x => isDefined(determineCatalogItem(terria.workbench, x)));

            // Return if `terria.selectedFeatures` already showing a valid feature?
            if (featuresShownAtAll.some(feature => feature === terria.selectedFeature)) return;

            // Otherwise find first feature with data to show
            let selectedFeature = featuresShownAtAll.filter(feature => isDefined(feature.properties) || isDefined(feature.description))[0];
            if (!isDefined(selectedFeature) && featuresShownAtAll.length > 0) {
              // Handles the case when no features have info - still want something to be open.
              selectedFeature = featuresShownAtAll[0];
            }
            runInAction(() => {
              terria.selectedFeature = selectedFeature;
            });
          });
        }
      }
    });
  }
  componentWillUnmount() {
    if (isDefined(this.pickedFeaturesReactionDisposer)) {
      this.pickedFeaturesReactionDisposer();
    }
  }
  renderFeatureInfoCatalogItems(catalogItems, featureMap) {
    return catalogItems.map((catalogItem, _i) => {
      var _ref;
      // From the pairs, select only those with this catalog item, and pull the features out of the pair objects.
      const features = (_ref = catalogItem.uniqueId ? featureMap.get(catalogItem.uniqueId) : undefined) !== null && _ref !== void 0 ? _ref : [];
      return /*#__PURE__*/_jsx(FeatureInfoCatalogItem, {
        viewState: this.props.viewState,
        catalogItem: catalogItem,
        features: features,
        onToggleOpen: this.toggleOpenFeature,
        printView: this.props.printView
      }, catalogItem.uniqueId);
    });
  }
  close() {
    this.props.viewState.featureInfoPanelIsVisible = false;

    // give the close animation time to finish before unselecting, to avoid jumpiness
    setTimeout(action(() => {
      this.props.viewState.terria.pickedFeatures = undefined;
      this.props.viewState.terria.selectedFeature = undefined;
    }), 200);
  }
  toggleCollapsed() {
    this.props.viewState.featureInfoPanelIsCollapsed = !this.props.viewState.featureInfoPanelIsCollapsed;
  }
  toggleOpenFeature(feature) {
    const terria = this.props.viewState.terria;
    if (feature === terria.selectedFeature) {
      terria.selectedFeature = undefined;
    } else {
      terria.selectedFeature = feature;
    }
  }
  getMessageForNoResults() {
    const {
      t
    } = this.props;
    if (this.props.viewState.terria.workbench.items.length > 0) {
      // feature info shows up becuase data has been added for the first time
      if (this.props.viewState.firstTimeAddingData) {
        runInAction(() => {
          this.props.viewState.firstTimeAddingData = false;
        });
        return t("featureInfo.clickMap");
      }
      // if clicking on somewhere that has no data
      return t("featureInfo.noDataAvailable");
    } else {
      return t("featureInfo.clickToAddData");
    }
  }
  addManualMarker(longitude, latitude) {
    const {
      t
    } = this.props;
    addMarker(this.props.viewState.terria, {
      name: t("featureInfo.userSelection"),
      location: {
        latitude: latitude,
        longitude: longitude
      }
    });
  }
  pinClicked(longitude, latitude) {
    if (!isMarkerVisible(this.props.viewState.terria)) {
      this.addManualMarker(longitude, latitude);
    } else {
      removeMarker(this.props.viewState.terria);
    }
  }

  // locationUpdated(longitude, latitude) {
  //   if (
  //     isDefined(latitude) &&
  //     isDefined(longitude) &&
  //     isMarkerVisible(this.props.viewState.terria)
  //   ) {
  //     removeMarker(this.props.viewState.terria);
  //     this.addManualMarker(longitude, latitude);
  //   }
  // }

  filterIntervalsByFeature(catalogItem, feature) {
    try {
      var _this$props$viewState;
      catalogItem.setTimeFilterFeature(feature, (_this$props$viewState = this.props.viewState.terria.pickedFeatures) === null || _this$props$viewState === void 0 ? void 0 : _this$props$viewState.providerCoords);
    } catch (e) {
      this.props.viewState.terria.raiseErrorToUser(e);
    }
  }
  renderLocationItem(cartesianPosition) {
    const cartographic = Ellipsoid.WGS84.cartesianToCartographic(cartesianPosition);
    if (cartographic === undefined) {
      return null;
    }
    const latitude = CesiumMath.toDegrees(cartographic.latitude);
    const longitude = CesiumMath.toDegrees(cartographic.longitude);
    const pretty = prettifyCoordinates(longitude, latitude);
    // this.locationUpdated(longitude, latitude);

    const that = this;
    const pinClicked = function () {
      that.pinClicked(longitude, latitude);
    };
    const locationButtonStyle = isMarkerVisible(this.props.viewState.terria) ? Styles.btnLocationSelected : Styles.btnLocation;
    return /*#__PURE__*/_jsxs("div", {
      className: Styles.location,
      children: [/*#__PURE__*/_jsx("span", {
        children: "Lat / Lon\xA0"
      }), /*#__PURE__*/_jsxs("span", {
        children: [pretty.latitude + ", " + pretty.longitude, !this.props.printView && /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: pinClicked,
          className: locationButtonStyle,
          children: /*#__PURE__*/_jsx(Icon, {
            glyph: Icon.GLYPHS.location
          })
        })]
      })]
    });
  }
  render() {
    var _terria$timelineClock, _terria$selectedFeatu;
    const {
      t
    } = this.props;
    const terria = this.props.viewState.terria;
    const viewState = this.props.viewState;
    const {
      catalogItems,
      featureMap
    } = getFeatureMapByCatalogItems(this.props.viewState.terria);
    const featureInfoCatalogItems = this.renderFeatureInfoCatalogItems(catalogItems, featureMap);
    const panelClassName = classNames(Styles.panel, {
      [Styles.isCollapsed]: viewState.featureInfoPanelIsCollapsed,
      [Styles.isVisible]: viewState.featureInfoPanelIsVisible,
      [Styles.isTranslucent]: viewState.explorerPanelIsVisible
    });
    const filterableCatalogItems = catalogItems.filter(catalogItem => TimeFilterMixin.isMixedInto(catalogItem) && catalogItem.canFilterTimeByFeature).map(catalogItem => {
      var _ref2;
      const features = (_ref2 = catalogItem.uniqueId ? featureMap.get(catalogItem.uniqueId) : undefined) !== null && _ref2 !== void 0 ? _ref2 : [];
      return {
        catalogItem: catalogItem,
        feature: isDefined(features[0]) ? features[0] : undefined
      };
    }).filter(pair => isDefined(pair.feature));

    // If the clock is available then use it, otherwise don't.
    const clock = (_terria$timelineClock = terria.timelineClock) === null || _terria$timelineClock === void 0 ? void 0 : _terria$timelineClock.currentTime;

    // If there is a selected feature then use the feature location.
    let position = (_terria$selectedFeatu = terria.selectedFeature) === null || _terria$selectedFeatu === void 0 || (_terria$selectedFeatu = _terria$selectedFeatu.position) === null || _terria$selectedFeatu === void 0 ? void 0 : _terria$selectedFeatu.getValue(clock);

    // If position is invalid then don't use it.
    // This seems to be fixing the symptom rather then the cause, but don't know what is the true cause this ATM.
    if (position === undefined || isNaN(position.x) || isNaN(position.y) || isNaN(position.z)) {
      position = undefined;
    }
    if (!isDefined(position)) {
      var _terria$pickedFeature;
      // Otherwise use the location picked.
      position = (_terria$pickedFeature = terria.pickedFeatures) === null || _terria$pickedFeature === void 0 ? void 0 : _terria$pickedFeature.pickPosition;
    }
    const locationElements = position ? /*#__PURE__*/_jsx("li", {
      children: this.renderLocationItem(position)
    }) : null;
    return /*#__PURE__*/_jsx(DragWrapper, {
      handleSelector: ".drag-handle",
      children: /*#__PURE__*/_jsxs("div", {
        className: panelClassName,
        "aria-hidden": !viewState.featureInfoPanelIsVisible,
        children: [!this.props.printView && /*#__PURE__*/_jsxs("div", {
          className: Styles.header,
          children: [/*#__PURE__*/_jsxs("div", {
            className: classNames("drag-handle", Styles.btnPanelHeading),
            children: [/*#__PURE__*/_jsx("span", {
              children: t("featureInfo.panelHeading")
            }), /*#__PURE__*/_jsx("button", {
              type: "button",
              onClick: this.toggleCollapsed,
              className: Styles.btnToggleFeature,
              children: this.props.viewState.featureInfoPanelIsCollapsed ? /*#__PURE__*/_jsx(Icon, {
                glyph: Icon.GLYPHS.closed
              }) : /*#__PURE__*/_jsx(Icon, {
                glyph: Icon.GLYPHS.opened
              })
            })]
          }), /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: this.close,
            className: Styles.btnCloseFeature,
            title: t("featureInfo.btnCloseFeature"),
            children: /*#__PURE__*/_jsx(Icon, {
              glyph: Icon.GLYPHS.close
            })
          })]
        }), /*#__PURE__*/_jsxs("ul", {
          className: Styles.body,
          children: [this.props.printView && locationElements,
          // Is feature info visible
          !viewState.featureInfoPanelIsCollapsed && viewState.featureInfoPanelIsVisible ?
          // Are picked features loading -> show Loader
          isDefined(terria.pickedFeatures) && terria.pickedFeatures.isLoading ?
          /*#__PURE__*/
          // Do we have no features/catalog items to show?
          _jsx("li", {
            children: /*#__PURE__*/_jsx(Loader, {
              light: true
            })
          }) : featureInfoCatalogItems.length === 0 ? /*#__PURE__*/_jsx("li", {
            className: Styles.noResults,
            children: this.getMessageForNoResults()
          }) :
          // Finally show feature info
          featureInfoCatalogItems : null, !this.props.printView && locationElements,
          // Add "filter by location" buttons if supported
          filterableCatalogItems.map(pair => TimeFilterMixin.isMixedInto(pair.catalogItem) && pair.feature ? /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: this.filterIntervalsByFeature.bind(this, pair.catalogItem, pair.feature),
            className: Styles.satelliteSuggestionBtn,
            children: t("featureInfo.satelliteSuggestionBtn", {
              catalogItemName: pair.catalogItem.name
            })
          }, pair.catalogItem.uniqueId) : null)]
        })]
      })
    });
  }
}, _applyDecoratedDescriptor(_class2.prototype, "close", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "close"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleCollapsed", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleCollapsed"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleOpenFeature", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleOpenFeature"), _class2.prototype), _class2)) || _class);
function getFeatureMapByCatalogItems(terria) {
  const featureMap = new Map();
  const catalogItems = new Set(); // Will contain a list of all unique catalog items.

  if (!isDefined(terria.pickedFeatures)) {
    return {
      featureMap,
      catalogItems: Array.from(catalogItems)
    };
  }
  terria.pickedFeatures.features.forEach(feature => {
    const catalogItem = determineCatalogItem(terria.workbench, feature);
    if (catalogItem !== null && catalogItem !== void 0 && catalogItem.uniqueId) {
      var _featureMap$get;
      catalogItems.add(catalogItem);
      if (featureMap.has(catalogItem.uniqueId)) (_featureMap$get = featureMap.get(catalogItem.uniqueId)) === null || _featureMap$get === void 0 || _featureMap$get.push(feature);else featureMap.set(catalogItem.uniqueId, [feature]);
    }
  });
  return {
    featureMap,
    catalogItems: Array.from(catalogItems)
  };
}
export function determineCatalogItem(workbench, feature) {
  if (MappableMixin.isMixedInto(feature._catalogItem) && workbench.items.includes(feature._catalogItem)) {
    return feature._catalogItem;
  }

  // Expand child members of composite catalog items.
  // This ensures features from each child model are treated as belonging to
  // that child model, not the parent composite model.
  const items = flatten(workbench.items.map(recurseIntoMembers)).filter(MappableMixin.isMixedInto);
  return items.find(item => featureBelongsToCatalogItem(feature, item));
}
function recurseIntoMembers(catalogItem) {
  if (catalogItem instanceof CompositeCatalogItem) {
    return flatten(catalogItem.memberModels.map(recurseIntoMembers));
  }
  return [catalogItem];
}
export { FeatureInfoPanel };
export default withTranslation()(withViewState(FeatureInfoPanel));